import { useEffect, useState } from "react"

export const ServicesTab = ({ service, selected, setSelected }) => {

    const [isSelected, setIsSelected] = useState(false)

    useEffect(() => {
        if(selected.includes(service)) {
            setIsSelected(true)
        }
    })

    return (

        <div className="col-12 col-md-12">
            <div className="checkboxStyleTwo">
                <input type="checkbox" id={`mfbc${service.id}`} checked={isSelected} onChange={(e) => {
                    if (e.target.checked) {
                        setIsSelected(true)
                        setSelected([...selected, service])
                    } else {
                        const newSelected = selected.filter((s) => {
                            if (s.id != service.id) {
                                return s
                            }
                        })
                        setSelected(newSelected)
                        setIsSelected(false)

                    }
                }} />
                <label htmlFor={`mfbc${service.id}`}>
                    <span>{service.name}</span>
                </label>
            </div>
        </div>


    )
}